export const DATASET_CATALOG_TYPE_ORDER = [
  'Meeting Data',
  'Chat Data',
  'File Data',
  'Generic',
] as const;

export const DATASET_CATALOG_GENERIC_TYPE = 'Generic';

export const DATASET_CATALOG_NEW_WINDOW_DAYS = 30;
